import HadithRulingsResultItem from './HadithRulingsResultItem';

export default HadithRulingsResultItem;
